signature := new Uint8Array [
  137, 80, 78, 71, 13, 10, 26, 10
]

titleKey := new Uint8Array [84, 105, 116, 108, 101, 0]

utf8Decoder := new TextDecoder
utf8Encoder := new TextEncoder

// http://www.libpng.org/pub/png/book/chapter08.html#png.ch08.div.1
// jsOn

// PNG Chunk
// | uint32 length | 4 character type | bytes[length] data | uint32 CRC |

/**
 * A PNG chunk with header, data and CRC
 *
 * http://www.libpng.org/pub/png/book/chapter08.html#png.ch08.div.1
 */
export type Chunk
  /** A four character ascii string indicating the type of chunk */
  type: string
  /** A buffer of just the data excluding header and CRC */
  data: Uint8Array
  crc: number
  /** The buffer containing the header, data, and CRC */
  raw: Uint8Array<ArrayBuffer>

/**
 * Create a PNG chunk with header, data and CRC
 */
Chunk := (type: string, data: Uint8Array): Chunk ->
  dataLength := data.length

  buffer := new Uint8Array 12 + dataLength

  writeInt32(buffer, dataLength, 0)

  typeBuffer := utf8Encoder.encode(type)
  if typeBuffer.length != 4
    /* c8 ignore next */
    throw new Error `Invalid chunk type: ${type}`
  buffer.set(typeBuffer, 4)

  buffer.set(data, 8)

  crc := computeCRC buffer.subarray(4, 8 + dataLength)
  writeInt32(buffer, crc, 8 + dataLength)

  type: type
  data: data
  crc: crc
  raw: buffer

export PNGUtil :=
  parse: (blob: Blob) ->
    buffer := await blob.arrayBuffer()

    // check signature
    b := new Uint8Array buffer

    signature.forEach (n, i) ->
      throw new Error "PNG signature doesn't match" unless b[i] is signature[i]

    // parse chunks
    pos .= 8
    {length} := b

    chunks := []

    while pos < length
      let chunk
      [chunk, pos] = parseChunk(b, pos)
      chunks.push chunk

    return chunks


  getJSON: (chunks: Chunk[]) ->
    [jsonChunk] := chunks.filter ({type}) ->
      type is "jsOn"

    if jsonChunk
      try
        JSON.parse utf8Decoder.decode(jsonChunk.data)

  blobWithJSON: (chunks: Chunk[], object: {}) ->
    // remove previous json chunks
    chunks = chunks.filter ({type, data}) ->
      type != "jsOn"

    jsonBytes := utf8Encoder.encode JSON.stringify(object)

    chunks.splice(-1, 0, Chunk("jsOn", jsonBytes))

    new Blob [signature].concat(chunks.map ({raw}) -> raw)

  getTitle: (chunks: Chunk[]) ->
    [titleChunk] := chunks.filter ({type, data}) ->
      titleKey.reduce (m, n, i) ->
        m and (data[i] is n)
      , type is "tEXt"

    let title
    if titleChunk
      {data} := titleChunk
      // Textual data is actually ISO/IEC 8859-1 (Latin-1) but I'd rather have it
      // as utf-8, this may or may not come back to bite me.
      // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.tEXt
      title = utf8Decoder.decode(data.subarray(titleKey.length, data.length))

    return title

  blobWithTitle: (chunks: Chunk[], title: string) ->
    // remove previous title chunk
    chunks = chunks.filter ({type, data}) ->
      !titleKey.reduce (m, n, i) ->
        m and (data[i] is n)
      , type is "tEXt"

    // Textual data is actually ISO/IEC 8859-1 (Latin-1) but I'd rather have it
    // as utf-8, this may or may not come back to bite me.
    // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.tEXt
    textBuffer := utf8Encoder.encode(title)
    dataLength := titleKey.length + textBuffer.length

    buffer := new Uint8Array 12 + dataLength

    // 4 byte length
    writeInt32(buffer, dataLength, 0)

    // tEXt
    buffer[4] = buffer[7] = "t".charCodeAt(0)
    buffer[5] = "E".charCodeAt(0)
    buffer[6] = "X".charCodeAt(0)

    // Title\0
    buffer.set titleKey, 8
    // textBuffer
    buffer.set textBuffer, 8 + titleKey.length

    // crc
    crc := computeCRC buffer.subarray(4, 8 + dataLength)
    writeInt32(buffer, crc, 8 + dataLength)

    // insert new title chunk before end
    // @ts-ignore
    chunks.splice(-1, 0, {raw: buffer})

    rawBuffers := chunks.map ({raw}) -> raw

    new Blob [signature].concat(rawBuffers),
      type: "image/png"

writeInt32 := (b: Uint8Array, i: number, pos: number) ->
  b[pos] = (i >> 24) & 0xff
  b[pos+1] = (i >> 16) & 0xff
  b[pos+2] = (i >> 8) & 0xff
  b[pos+3] = i & 0xff

  return

parseInt32 := (b: Uint8Array, pos: number) ->
  l := (b[pos]   << 24) +
      (b[pos+1] << 16) +
      (b[pos+2] <<  8) +
      (b[pos+3])

  return [l, pos + 4] as const

parseType := (b: Uint8Array, pos: number) ->
  type := String.fromCharCode b[pos], b[pos+1], b[pos+2], b[pos+3]

  return [type, pos+4] as const

parseChunk := (b: Uint8Array<ArrayBuffer>, pos: number) ->
  let length: number, type: string, crc: number
  start := pos

  [length, pos] = parseInt32(b, pos)
  [type, pos] = parseType(b, pos)
  data := b.subarray(pos, pos += length)
  [crc, pos] = parseInt32(b, pos)

  computedCRC := computeCRC(b.subarray(start+4, start+8+length))

  unless (crc ^ computedCRC) is 0
    throw new Error "CRC mismatch"

  r :=
    type: type
    data: data
    crc: crc
    raw: b.subarray(start, pos)

  [r, pos] as const

// PNG CRC
// http://www.libpng.org/pub/png/spec/1.2/PNG-CRCAppendix.html

crc_table := Array(256)

n .= 0
while n < 256
  c .= n
  k .= 0
  while k < 8
    if c & 1
      c = 0xedb88320 ^ (c >>> 1)
    else
      c = c >>> 1
    k++

  crc_table[n] = c >>> 0
  n++

computeCRC := (buf: Uint8Array) ->
  c .= -1
  n .= 0
  len := buf.length
  while n < len
    c = (c >>> 8) ^ crc_table[(c ^ buf[n]) & 0xff]
    n++

  return (c ^ -1) >>> 0

export default PNGUtil
